// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + ({"430":"pirate-ship-game","520":"game-map-3d","941":"treasure-island-game"}[chunkId] || chunkId) + "." + {"430":"70f616b0","489":"756db8c5","520":"95feafb4","941":"e5ef17df"}[chunkId] + ".css";
};